import { Section, SectionSubTitle, Typography } from 'common/components';
import React from 'react';
import { createElementKey } from 'utils';
import { ORDER_STEPS_DATA } from './order-steps-constants';
import { orderStepsSection, orderStepsList, orderStepImage, orderStepName } from './order-steps-styles';

export const OrderSteps: React.FC = () => (
  <Section className={orderStepsSection}>
    <SectionSubTitle margin="m">Как заказать модульную кухню</SectionSubTitle>
    <ul className={orderStepsList}>
      {ORDER_STEPS_DATA.map((step, index) => (
        <li key={createElementKey('order-step', index)}>
          <img
            className={orderStepImage}
            src={step.imageSrc}
            alt={step.imageAlt}
            title={step.imageAlt}
            width="64"
            height="64"
            loading="lazy"
          />
          <Typography className={orderStepName} variant="h3">
            {step.title}
          </Typography>
          <Typography variant="s" size="body_long">
            {step.description}
          </Typography>
        </li>
      ))}
    </ul>
  </Section>
);
